import { Box, IconCritical, TooltipRenderer, Text } from 'braid-design-system';

interface Props {
  message?: string;
  id: string;
}

const Tooltip = ({ message, id }: Props) => {
  if (!message) return null;

  return (
    <TooltipRenderer
      placement="bottom"
      tooltip={<Text>{message}</Text>}
      id={id}
    >
      {({ triggerProps }) => (
        <Box
          component="span"
          aria-label="paymentMethodUnavailable"
          {...{ ...triggerProps, zIndex: 1, position: 'relative' }}
        >
          <IconCritical tone="critical" />
        </Box>
      )}
    </TooltipRenderer>
  );
};

export default Tooltip;
